import React from 'react';
import {compose} from 'recompose';
import block from 'bem-cn-lite';
import {AnimateBlock} from '@yandex-data-ui/page-constructor';

import withPageContext from 'units/constructor-local/hoc/withPageContext';
import {PageContextProps} from 'units/constructor-local/contexts/PageContext';
import TranslateDemo from 'components/TranslateDemo/TranslateDemo';
import SpeechKitDemo from 'components/SpeechKitDemo/SpeechKitDemo';
import {withDesktopOnly} from 'units/constructor-local/hoc/WithDesktopOnly';
import {ServiceDemoProps} from 'units/constructor-local/models';

import './ServiceDemo.scss';

const b = block('ServiceDemoBlock');

type ServiceDemoFullProps = PageContextProps & ServiceDemoProps;

interface DemoComponentProps {
    isConstructorVersion?: boolean;
}

function getDemoComponent(
    service: PageContextProps['service'],
): React.ComponentType<DemoComponentProps> | null {
    switch (service?.slug) {
        case 'speechkit':
            return SpeechKitDemo;
        case 'translate':
            return TranslateDemo;
        default:
            return null;
    }
}

export function hasDemo(service: PageContextProps['service']) {
    return getDemoComponent(service) !== null;
}

const ServiceDemoBlock: React.FC<ServiceDemoFullProps> = ({service, animated}) => {
    const Component = getDemoComponent(service);

    return (
        Component && (
            <AnimateBlock className={b()} animate={animated}>
                <Component isConstructorVersion={true} />
            </AnimateBlock>
        )
    );
};

export default compose<{}, PageContextProps>(withDesktopOnly, withPageContext)(ServiceDemoBlock);
